// extracted by mini-css-extract-plugin
export default {"toggleSwitchWrapper":"fee-types-page_toggleSwitchWrapper__+xgap","toggleLabel":"fee-types-page_toggleLabel__KJ+tL"};